// This is your plugin object. It can be exported to be used anywhere.
const createUrl = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    Vue.prototype.$urlBeautify = (item) => {
      // Create a pretty URL (including some title info)
      return encodeURI(item.replace(/[^\w\s]/gi, '').replace(/[\s]/gi, "-").toLowerCase());
    }
  }
};

// Usage example:
// {{ $urlBeautify(article.title) }}
export default createUrl;



// WEBPACK FOOTER //
// ./src/plugins/url.js